import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import {
  FULL_WIDTH_ICON_NAVIGATION_CONVERTER_TOKEN, FullWidthIconNavigationConverter
} from './full-width-icon-navigation.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        fullWidthIconNavigationFeature: {
          module: () => import('./full-width-icon-navigation.module').then((m) => m.FullWidthIconNavigationModule),
          cmsComponents: ['full_width_icon_navigation'],
        },
      }
    }),
    {
      provide: FULL_WIDTH_ICON_NAVIGATION_CONVERTER_TOKEN,
      useExisting: FullWidthIconNavigationConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        full_width_icon_navigation: FULL_WIDTH_ICON_NAVIGATION_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class FullWidthIconNavigationFeatureModule {}
